import { NewsletterPerBook } from './NewsletterPerBook';

export default NewsletterPerBook;